import { render, staticRenderFns } from "./SortSelectIcon.vue?vue&type=template&id=7ed8af3b&"
import script from "./SortSelectIcon.vue?vue&type=script&lang=js&"
export * from "./SortSelectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports